import { useState, useEffect, MutableRefObject } from 'react';

type ElementRef = MutableRefObject<HTMLElement | null>;

export function useScroll({ elementRef, selector } : { elementRef: ElementRef, selector: string }) {
  const [scrollTop, setScrollTop] = useState(0);
  const [scrolledToBottom, setScrolledToBottom] = useState(false);

  const listener = (e: Event) => {
    const target = e.target as HTMLElement;
    let maxScroll = target.scrollHeight - target.clientHeight;
    setScrollTop(target.scrollTop)
    setScrolledToBottom(target.scrollTop === maxScroll);
  };

  useEffect(() => {
    const element = elementRef.current?.querySelector(selector);
    element?.addEventListener("scroll", listener);
    return () => {
      element?.removeEventListener("scroll", listener);
    };
  });

  return {
    scrollTop,
    scrolledToBottom
  };
}